import React from 'react';
import {observer} from 'mobx-react';
import {Column, HeaderColumn, Row} from '@vidazoo/ui-kit';
import useReportingModel from '../../common/hooks/useReportingModel';
import useReportingBuildManager from "../../common/hooks/useReportingBuildManager";
import theme from '../../view/theme.module.scss';

export const ReportingTableHeader = observer(function ReportingTableHeader() {
    const {requestedFields, requestedGroups} = useReportingBuildManager();
    const model = useReportingModel();

    if (model.isLoading || !model.data) {
        return null;
    }

    return (
        <>
            <Row className={theme.tableHeading}>
                {requestedGroups.map((group) => (
                    <HeaderColumn appearance="classic" disableNowrap key={group.value} colKey={group.value}/>))}
                {requestedFields.map((field, index) => (
                    <HeaderColumn disableSearch={index > 0} appearance="classic" disableNowrap key={field.value} colKey={field.value}
                        contextMenuItems={[{label: field.type === 'formula' ? 'Update Dynamic Formula' : 'Create Dynamic Formula',
                            onClick: () => model.editDynamicFormula(field)}]}/>))}
            </Row>
            <Row className={theme.summary}>
                {requestedGroups.map((group, index) => (
                    <Column key={group.value} colKey={group.value}>
                        {index === 0 && `Total Rows: ${model.maskItems.length.toLocaleString()}`}
                    </Column>
                ))}
                {requestedFields.map((field) => (
                    <Column key={field.value} colKey={field.value}>
                        {model.maskItemsTotal[field.value]}
                    </Column>
                ))}
            </Row>
        </>
    )
});
